module.exports = __webpack_public_path__ + "static/media/2025.1a0c8a68.png";